export default "__VITE_ASSET__67f94d0c__"